import { render, staticRenderFns } from "./DiamondCard.vue?vue&type=template&id=3565c183"
import script from "./DiamondCard.vue?vue&type=script&lang=js"
export * from "./DiamondCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports